import '@babel/polyfill'
import 'mutationobserver-shim'
import Vue from 'vue'
import store from './store'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify';
import axios from '../src/plugins/axios'
import vueDebounce from 'vue-debounce'
import VueMask from 'v-mask'
import '../public/css/custom.css'
import '../public/css/custom.scss'
import VueHtmlToPaper from 'vue-html-to-paper';
import VueSignaturePad from "vue-signature-pad";
import DatetimePicker from "vuetify-datetime-picker";
// import VueFusionCharts from 'vue-fusioncharts';
// import FusionCharts from 'fusioncharts';
// import Charts from 'fusioncharts/fusioncharts.charts';

// //import the theme
// import FusionTheme from 'fusioncharts/themes/fusioncharts.theme.fusion'

// Vue.use(VueFusionCharts, FusionCharts, Charts, Fusion)
Vue.use(VueSignaturePad);
Vue.use(VueHtmlToPaper);
Vue.use(VueMask);
Vue.use(vueDebounce);
Vue.use(DatetimePicker);
Vue.config.productionTip = false
Vue.prototype.$axios = axios
new Vue({
  store,
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
